
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/financialMedicalTransactions",
      function () {
        return require("private-next-pages/[lang]/financialMedicalTransactions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/financialMedicalTransactions"])
      });
    }
  